import type { ComponentOptions } from 'vue';
import Vue from 'vue';
import { LS } from '@mx/util/local-storage';
import { modal, toast } from '@mx/vix';
import type { RouteConfig } from 'vue-router';
import Router from 'vue-router';
import App from './App.vue';
import '@/styles/common.less';
import { env, bridge, monitor, initMiniProgramLx } from '@/common';
import lowVersionTitansx from '@/common/lowVersion';
/**
 * 页面渲染打点收集
 */
import { initCollector } from '../common/pgyCollect/pgyDirective';
import { getCookieConfig } from '../common/pgyCollect/abConfig';

// abType - 自定义ab实验参数（一般取项目名称，比如fe_mall）
const { collect, collector } = initCollector({ abType: 'balanceIndexPage', cookieConfig: getCookieConfig() });
Vue.directive('pgy-collect', collect);
Vue.prototype.$collector = collector;

Vue.use(Router);
Vue.prototype.$modal = modal;
Vue.prototype.$toast = toast;

export default function init(routes: RouteConfig[], options?: ComponentOptions<any>) {
  const router = new Router({
    routes,
  });

  Vue.use(lowVersionTitansx, { router });
  Vue.config.productionTip = false;
  // 强制要求接入方传入scene
  const scene = env.scene;
  if (!scene && process.env.NODE_ENV !== 'development') {
    monitor.captureMessage('没有传入参数scene');
  }

  if (LS.get('inWeixinMini')) {
    env.inWeixinMini = true;
  }

  initMiniProgramLx();

  if (env.isNative) {
    bridge.setTitle(' ');
  }

  KNB.ready(() => {
    if (KNB.isMiniProgramWebview) {
      env.inWeixinMini = true;
      LS.set('inWeixinMini', '1');
    } else {
      LS.remove('inWeixinMini');
      env.inWeixinMini = false;
    }

    KNB.setLLButton({
      icon: '',
      handle: () => {
        // 修改：安卓手机手机自带的返回键无效的问题
        bridge.closePage();
      },
    });
    KNB.setNavigationBarHidden({
      flag: 1,
    });
  });
  new Vue({
    ...options,
    router,
    render: (h) => h(App),
  }).$mount('#app');
}
